module.exports = __webpack_public_path__ + "img/casajarseblanco.06b0d903.png";